// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","phone-only":"(max-width: calc(calc(768 * 1px) - 1px))","container":"CardContainer_container__3QOXF"};